import Controller from '@ember/controller';
import { get, getProperties, set, setProperties } from '@ember/object';
import { service } from '@ember/service';
import { Promise } from 'rsvp';
import ENV from 'donor-elf-web/config/environment';
import { task } from 'ember-concurrency';

export default Controller.extend({
  currentUser: service(),
  fundsService: service(),
  store: service(),

  error: null,
  showValidationErrors: false,
  complete: false,

  reset() {
    setProperties(this, {
      error: null,
      showValidationErrors: false,
      complete: false,
    });
  },

  saveToStripe(changeset) {
    return new Promise((resolve, reject) => {
      window.Stripe.setPublishableKey(ENV.APP.stripePublishableKey);
      window.Stripe.card.createToken(
        getProperties(changeset, 'number', 'exp_month', 'exp_year', 'cvc'),
        (status, response) => {
          if (status === 200) {
            resolve(response);
          } else {
            if (get(response, 'error.param') != null) {
              changeset.pushErrors(
                response.error.param,
                response.error.message,
              );
            }
            reject(response);
          }
        },
      );
    });
  },

  save: task(function* () {
    let changeset = get(this, 'model.changeset');
    try {
      yield changeset.validate();
      set(this, 'showValidationErrors', true);
      if (get(changeset, 'isValid')) {
        let stripeResponse = yield this.saveToStripe(changeset);
        yield this.fundsService.confirmValidFundToken();
        let stripeCustomer = this.store.createRecord('stripe-customer', {
          stripeCardToken: stripeResponse.id,
          cardExpiresMonth: stripeResponse.card.exp_month,
          cardExpiresYear: stripeResponse.card.exp_year,
        });
        yield stripeCustomer.save();
        set(this, 'complete', true);
        // set it to false for now
        set(this.currentUser, 'stripeIsDelinquent', false);
      }
    } catch (error) {
      if (get(changeset, 'isValid')) {
        set(this, 'error', error);
      }
    }
  }).drop(),
});
